import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { GAME_MODES } from '../../core/constats';

import { BonusBoardMobileDrawer } from './drawers/BonusBoardMobileDrawer';
import { BonusBoardDesktopDrawer } from './drawers/BonusBoardDesktopDrawer';
import { BonusBoardLandscapeDrawer } from './drawers/BonusBoardLandscapeDrawer';

class BonusBoardDrawer extends BaseParentControlDrawer {
}

export const bonusBoardDrawer = new BonusBoardDrawer({
  [GAME_MODES.MOBILE]: new BonusBoardMobileDrawer(),
  [GAME_MODES.MOBILE_LANDSCAPE]: new BonusBoardLandscapeDrawer(),
  [GAME_MODES.DESKTOP]: new BonusBoardDesktopDrawer(),
});

